import { render, staticRenderFns } from "./editOwner.vue?vue&type=template&id=a8c1d9ac&scoped=true"
import script from "./editOwner.vue?vue&type=script&lang=js"
export * from "./editOwner.vue?vue&type=script&lang=js"
import style0 from "./editOwner.vue?vue&type=style&index=0&id=a8c1d9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c1d9ac",
  null
  
)

export default component.exports